// extracted by mini-css-extract-plugin
module.exports = {"view":"_404_view_lPEpm","content":"_404_content_8rG81"};